import InfoIcon from "@redotech/redo-icons/info-circle.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useId, useState } from "react";

export const DynamicRatePricingExample = memo(
  function DynamicRatePricingExample() {
    const [open, setOpen] = useState(false);
    const exampleId = useId();
    return (
      <Flex dir="column" gap="sm" w="full">
        <Flex align="flex-start" gap="lg" justify="space-between" w="full">
          <Flex flex="1">
            <Text fontSize="sm" textColor="secondary">
              Map each service to the benchmarks it should beat. Pricing beats
              the cheaper of Redo and merchant rates for the selected benchmark
              services, without pricing below Redo cost. We will adjust all
              rates dynamically.
            </Text>
          </Flex>
          <Flex shrink="0">
            <RedoButton
              aria-controls={exampleId}
              aria-expanded={open}
              hierarchy="tertiary"
              IconLeading={InfoIcon}
              onClick={() => setOpen(!open)}
              size="sm"
              text={open ? "Hide example" : "Show example"}
            />
          </Flex>
        </Flex>
        {open && (
          <Flex
            borderColor="secondary"
            borderRadius="md"
            borderStyle="solid"
            borderWidth="1px"
            dir="column"
            gap="sm"
            id={exampleId}
            p="lg"
            w="full"
          >
            <Text fontSize="sm" fontWeight="medium">
              Example: DHL Ground mapped to USPS Ground Advantage and UPS Ground
            </Text>
            <Text fontSize="sm" textColor="secondary">
              Redo's USPS rate is $6.50. The merchant's USPS rate is $6.00.
              Redo's UPS is $7.00. The benchmark is $6.00—the cheaper of those
              rates.
            </Text>
            <Text fontSize="sm" textColor="secondary">
              With savings set to $0.10–$0.30, we randomly select somewhere in
              that range - say $0.20. DHL Ground costs Redo $4.00, and we
              initially mark it up to $9 using rate tables. To beat the $6
              benchmark by 0.20, we change the DHL rate to be $5.80. Redo's cost
              stays $4.00.
            </Text>
            <Text fontSize="sm" textColor="secondary">
              Prices stay unchanged if they are already below the benchmark or
              cannot beat the benchmark by the minimum savings without going
              below Redo cost. Competitive spread may then lower a rate further
              to beat the currently selected rate when doing so would improve
              Redo's margin.
            </Text>
          </Flex>
        )}
      </Flex>
    );
  },
);
